"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInvitation = exports.isInvitation = void 0;
const __1 = require("..");
function isInvitation(object) {
    return checkInvitation(object).fulfilled;
}
exports.isInvitation = isInvitation;
function checkInvitation(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasChoice)("resourceType", ["company", "project"]), (0, __1.hasString)("resourceId"), (0, __1.hasNumber)("creationDate").integer(), (0, __1.hasString)("creatorId"), (0, __1.hasString)("inviteeEmail"), (0, __1.hasMap)("context", (0, __1.isAny)()).optional(), (0, __1.hasChoice)("state", ["open", "read", "accepted", "declined"]), (0, __1.hasNumber)("expirationDate").integer().optional(), (0, __1.hasString)("link").optional()).withOptions(options).explain();
}
exports.checkInvitation = checkInvitation;
//# sourceMappingURL=Invitation.js.map